var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.criticalLevel && _vm.stateLabel)?_c('el-tag',{attrs:{"size":"medium","type":_vm.cssClass}},[_vm._v(_vm._s(_vm.stateLabel)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94dc8e2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/adminstration/dieuxe/hc-phonghop-critical-level-tag.vue
// module id = null
// module chunks = 